<template>
  <div class="order">
    <ul>
      <li
        v-for="(item, index) of orderlist"
        :key="index"
        class="orderlist"
      >
        <div class="head">
          <p>{{ item.order_shop }}</p>
          <p>{{ item | orderstatus }}</p>
        </div>
        <ul>
          <li
            v-for="(item2, index2) of item.order_goods"
            :key="index2"
          >
            <div class="list">
              <div class="image"><img :src="item2.goods_pic" /></div>
              <div class="goods-content">
                <div>
                  <p>{{ item2.goods_name }}</p>
                </div>
                <div class="goods-price">
                  <span>{{ $setInfoDecimal(item2.goods_price) }} 积分</span>
                  <span>X{{ item2.goods_num }}</span>
                </div>
              </div>
            </div>
            <div class="btn">
              <div>
                <!-- <button @click="service(item2.goods_id)">售后服务</button> -->
              </div>
              <!-- <div><button @click="">再次购买</button></div> -->
            </div>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
import { getorderlist } from '@/api/order'
import scroll from '@/mixins/scroll'
import { orderlist } from '../my/component'
export default {
  data () {
    return {
      orderlist: []
    }
  },
  mixins: [scroll],
  methods: {
    async getList () {
      const result = await getorderlist({ page: this.page, size: 8, order_status: 0 })
      if (result.data.data.orderList.data.length !== 0) {
        this.orderlist = this.orderlist.concat(result.data.data.orderList.data)
      } else {
        this.page = null
      }
    },
    service (sn) {
      this.$router.push({
        name: 'service',
        query: {
          id: sn
        }
      })
    }
  },
  filters: {
    orderstatus (value) {
      if (value.cancel_status === 1 || value.order_status === 9) {
        return '订单取消'
      } else {
        return value.after_sale_status ? '存在售后' : '订单正常'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.order {
  font-size: 0.28rem;
  .orderlist {
    background: white;
    width: 6.88rem;
    margin: auto;
    margin-top: 0.4rem;
    padding: 0.2rem;
    border-radius: 10px;
    .head {
      display: flex;
      justify-content: space-between;
      p {
        margin: 0;
      }
      p:nth-child(1) {
        font-weight: 800;
      }
      p:nth-child(2) {
        font-weight: 800;
        color: #ff6161;
      }
    }
    .list {
      display: flex;
      justify-content: space-between;
      margin: 0.1rem 0;
      padding: 0.1rem 0;
      .image {
        width: 1.71rem;
        height: 1.71rem;
      }
      .goods-content {
        width: 4.68rem;
      }
      .goods-price {
        span:nth-child(1) {
          font-weight: 800;
        }
        span:nth-child(2) {
          margin-left: 0.1rem;
          color: #666666;
        }
      }
    }
  }
  .btn {
    display: flex;
    justify-content: flex-end;
    padding-bottom: 0.1rem;
    border-bottom: 1px solid rgb(243, 243, 243);
    button {
      margin-left: 0.2rem;
      border: 1px solid #999999;
      border-radius: 30px;
      color: #999999;
      background: white;
      padding: 0 0.1rem;
    }
  }
}
</style>
